import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-pre-loading',
    templateUrl: './pre-loading.component.html',
    styleUrl: './pre-loading.component.scss',
    standalone: false
})
export class PreLoadingComponent {

	@Input() msg!: string
	@Input() large = true
	@Input() grow = false
	@Input() showMessage = true
}
